module.exports = __webpack_public_path__ + "img/grid-picture-2x1.c5fbe22f.jpg";